






























import { Component } from 'vue-property-decorator'
import BaseArticleFooter from '../../../../../base/components/content/detail-view/elements/ArticleFooter.vue'
import KleineArticles from '~components/content/widgets/KleineArticles.vue'

@Component({
  components: {
    KleineArticles,
  },
})
export default class ArticleFooter extends BaseArticleFooter {}
